import bannerAPI from '@/api/banner-api'

export default {
  state: {
    bannerList: []
  },
  getters: {
    getBannerList (state) {
      return state.bannerList
    }
  },
  mutations: {
    setBannerList (state, value) {
      state.bannerList = value
    },
    clearBannerList (state) {
      state.bannerList = []
    }
  },
  actions: {
    GET_ALL_BANNERS ({ commit }, { success = null, fail = null } = {}) {
      bannerAPI.getAllBanners().then(response => {
        if (response.body.success) {
          commit('setBannerList', response.body.content)
          success && success(response.body)
        } else {
          fail && fail()
        }
      }).catch(() => {
        fail && fail()
      })
    }
  },
  namespaced: true
}
